import { Box } from 'native-base';
import React from 'react';

import CPModal from 'app/components/CPModal';
import TicketCarousel from 'app/components/TicketCarousel';
import useWindow from 'app/hooks/useWindow';
import {
  EntitlementReservation,
  Pass,
  TicketCategory,
} from 'app/services/GuestCenterService.types';
import { tID } from 'app/services/TestHelper';
import { MAX_WIDTH_WEB } from 'app/theme/breakpoints';

const SCROLL_GUTTER_WEB = 10;

export type TicketCarouselModalProps = {
  isOpen: boolean;
  onClose: () => void;
  passes: Pass[];
  reservation?: EntitlementReservation;
  orderNumber?: string;
  ticketCategory?: TicketCategory;
  attractionKey?: string;
};

export default function TicketCarouselModal({
  isOpen,
  onClose,
  passes,
  reservation,
  orderNumber,
  ticketCategory,
  attractionKey,
}: TicketCarouselModalProps) {
  const { rawWidth } = useWindow();

  return (
    <Box testID={tID('TicketCarouselModal')}>
      <CPModal
        blurBackdrop
        closeOnOverlayClick={false}
        isOpen={isOpen}
        size="full"
        onClose={onClose}
      >
        <CPModal.Content
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore: boxShadow is a valid style prop for web
          _web={{ style: { boxShadow: 'none' } }}
          bgColor="transparent"
          maxH="95%"
          rounded="none"
          style={{ elevation: 0 }}
        >
          <CPModal.CloseButton
            _icon={{ color: '#373737' }}
            _web={{
              right:
                rawWidth > MAX_WIDTH_WEB ? (rawWidth - MAX_WIDTH_WEB) / 2 + SCROLL_GUTTER_WEB : 2,
            }}
            bg="white"
            opacity=".9"
            right="2"
            rounded="full"
            top="1"
          />
          <CPModal.Body
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: boxShadow is a valid style prop for web
            _web={{ style: { boxShadow: 'none' } }}
            bgColor="transparent"
            mt="3"
            p="0"
            shadow="0"
            style={{ elevation: 0 }}
            w="full"
          >
            {isOpen && (
              <TicketCarousel
                attractionKey={attractionKey}
                orderNumber={orderNumber}
                passes={passes}
                reservation={reservation}
                ticketCategory={ticketCategory}
              />
            )}
          </CPModal.Body>
        </CPModal.Content>
      </CPModal>
    </Box>
  );
}
